import React, { useState } from 'react';
import RichTextEditor from 'react-rte';

const TestComponent = ({ onChange, title, textvalue, errorClass }) => {
  const [editorValue, setEditorValue] = useState(RichTextEditor.createValueFromString(textvalue || '', 'html'));

  const handleChange = (value) => {
    setEditorValue(value);
    if (onChange) {
      onChange(value.toString('html')); // Update the form field with the HTML string
      console.log('text', value.toString('html'));
    }
  };
  // console.log('text', value.toString('html'));

  const toolbarConfig = {
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
      { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
      { label: 'Italic', style: 'ITALIC' },
      { label: 'Underline', style: 'UNDERLINE' },
    ],

    BLOCK_TYPE_BUTTONS: [
      { label: 'UL', style: 'unordered-list-item' },
      { label: 'OL', style: 'ordered-list-item' },
      
    ],

    // BLOCK_TYPE_DROPDOWN:[
    //   { label: 'Normal', style: 'unstyled' },
    //   { label: 'Header 1', style: 'header-one' },
    //   { label: 'Header 2', style: 'header-two' },
    //   { label: 'Header 3', style: 'header-three' },
    //   { label: 'Header 4', style: 'header-four' },
    //   { label: 'Header 5', style: 'header-five' },
    //   { label: 'Header 6', style: 'header-six' },
    // ],
  };

  // Custom styles for font sizes
  const customStyleMap = {
    FONT_SIZE_14: { fontSize: '14px' },
    FONT_SIZE_16: { fontSize: '16px' },
    FONT_SIZE_20: { fontSize: '20px' },
    FONT_SIZE_24: { fontSize: '24px' },
  };

  // Handle custom font size toggling
  const handleFontSizeToggle = (style) => {
    const editorState = editorValue.getEditorState();
    const newState = RichUtils.toggleInlineStyle(editorState, style);
    setEditorValue(editorValue.setEditorState(newState));
  };

  return (
    <>
      {title && <label htmlFor={name}>{title}</label>}
   
      <RichTextEditor
        className={`rounded-3 ${errorClass && 'rich-text-editor-error'}`}
        // customStyleMap={customStyleMap} // Pass custom styles
        toolbarConfig={toolbarConfig}
        value={editorValue}
        onChange={handleChange}
      />
    </>
  );
};

export default TestComponent;


